module.exports = __webpack_public_path__ + "img/kong-haoyou.5addeb50.png";